import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, Injectable, NgModule } from '@angular/core';
import { format } from 'date-fns';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import * as i3 from '@busacca/ng-pick-datetime';
import { OwlDateTimeIntl, OwlDateTimeModule, OwlNativeDateTimeModule } from '@busacca/ng-pick-datetime';
import * as i4 from '@beego/ngx-filter';
import { FilterModule } from '@beego/ngx-filter';

class DateFilterComponent {
    name;
    dateRange;
    filter = new EventEmitter();
    current;
    ngOnInit() {
        if (this.dateRange) {
            this.current = this.getDateRangeString(this.dateRange);
        }
    }
    filterData(_event) {
        this.current = null;
        const startDate = format(_event.value[0], 'yyyy-MM-dd');
        const endDate = format(_event.value[1], 'yyyy-MM-dd');
        this.dateRange = { startDate, endDate };
        this.filter.emit({ startDate, endDate });
    }
    /**
     * A helper function to format a {@link IDateRange} object into a string
     *
     * @param {IDateRange} dateRange The date range that needs to be formatted into a string
     * @returns {string} The formatted date range as string
     */
    getDateRangeString(dateRange) {
        return `${format(new Date(dateRange.startDate), 'd/M/yyyy')} - ${format(new Date(dateRange.endDate), 'd/M/yyyy')}`;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DateFilterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: DateFilterComponent, selector: "date-filter-component", inputs: { name: "name", dateRange: "dateRange" }, outputs: { filter: "filter" }, ngImport: i0, template: "<filter-component [name]=\"name\">\n    <ng-container filter-content>\n        <span class=\"_date-range\" [owlDateTimeTrigger]=\"dt\">\n            <span class=\"_default\" *ngIf=\"dateRange\">{{current}}</span>\n            <input required #dateInput (dateTimeChange)=\"filterData($event)\" class=\"_date-input\" selectMode=\"range\" rangeSeparator=\"-\" [owlDateTime]=\"dt\" >\n            <owl-date-time #dt pickerType=\"calendar\" [firstDayOfWeek]=\"1\"></owl-date-time>\n            <ion-icon src=\"./assets/icons/arrow-small-down.svg\"></ion-icon>\n        </span>\n    </ng-container>\n</filter-component>\t", styles: ["._date-range{margin-left:20px;display:flex;flex-direction:row;align-items:center}._date-range:hover{cursor:pointer}._date-range ._default{white-space:nowrap}._date-range ._date-input{border:none;color:transparent;text-shadow:0 0 0 black}._date-range ._date-input:required:invalid{width:10px}._date-range ._date-input:hover{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }, { kind: "directive", type: i3.OwlDateTimeTriggerDirective, selector: "[owlDateTimeTrigger]", inputs: ["owlDateTimeTrigger", "disabled"] }, { kind: "directive", type: i3.OwlDateTimeInputDirective, selector: "input[owlDateTime]", inputs: ["owlDateTime", "owlDateTimeFilter", "_disabled", "min", "max", "selectMode", "rangeSeparator", "value", "values"], outputs: ["dateTimeChange", "dateTimeInput"], exportAs: ["owlDateTimeInput"] }, { kind: "component", type: i3.OwlDateTimeComponent, selector: "owl-date-time", inputs: ["backdropClass", "panelClass", "startAt", "pickerType", "pickerMode", "disabled", "opened", "scrollStrategy"], outputs: ["afterPickerClosed", "afterPickerOpen", "yearSelected", "monthSelected"], exportAs: ["owlDateTime"] }, { kind: "component", type: i4.DataFilterComponent, selector: "filter-component", inputs: ["name"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DateFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'date-filter-component', template: "<filter-component [name]=\"name\">\n    <ng-container filter-content>\n        <span class=\"_date-range\" [owlDateTimeTrigger]=\"dt\">\n            <span class=\"_default\" *ngIf=\"dateRange\">{{current}}</span>\n            <input required #dateInput (dateTimeChange)=\"filterData($event)\" class=\"_date-input\" selectMode=\"range\" rangeSeparator=\"-\" [owlDateTime]=\"dt\" >\n            <owl-date-time #dt pickerType=\"calendar\" [firstDayOfWeek]=\"1\"></owl-date-time>\n            <ion-icon src=\"./assets/icons/arrow-small-down.svg\"></ion-icon>\n        </span>\n    </ng-container>\n</filter-component>\t", styles: ["._date-range{margin-left:20px;display:flex;flex-direction:row;align-items:center}._date-range:hover{cursor:pointer}._date-range ._default{white-space:nowrap}._date-range ._date-input{border:none;color:transparent;text-shadow:0 0 0 black}._date-range ._date-input:required:invalid{width:10px}._date-range ._date-input:hover{cursor:pointer}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], dateRange: [{
                type: Input
            }], filter: [{
                type: Output
            }] } });

class DefaultIntl extends OwlDateTimeIntl {
    /** A label for the up second button (used by screen readers).  */
    upSecondLabel = 'Seconde toevoegen';
    /** A label for the down second button (used by screen readers).  */
    downSecondLabel = 'Seconde aftrekken';
    /** A label for the up minute button (used by screen readers).  */
    upMinuteLabel = 'Minuut toevoegen';
    /** A label for the down minute button (used by screen readers).  */
    downMinuteLabel = 'Minuut aftrekken';
    /** A label for the up hour button (used by screen readers).  */
    upHourLabel = 'Uur toevoegen';
    /** A label for the down hour button (used by screen readers).  */
    downHourLabel = 'Uur aftrekken';
    /** A label for the previous month button (used by screen readers). */
    prevMonthLabel = 'Vorige maand';
    /** A label for the next month button (used by screen readers). */
    nextMonthLabel = 'Volgende maand';
    /** A label for the previous year button (used by screen readers). */
    prevYearLabel = 'Vorig jaar';
    /** A label for the next year button (used by screen readers). */
    nextYearLabel = 'Volgend jaar';
    /** A label for the previous multi-year button (used by screen readers). */
    prevMultiYearLabel = 'Vorige 21 jaar';
    /** A label for the next multi-year button (used by screen readers). */
    nextMultiYearLabel = 'Volgende 21 jaar';
    /** A label for the 'switch to month view' button (used by screen readers). */
    switchToMonthViewLabel = 'Verander naar maand weergave';
    /** A label for the 'switch to year view' button (used by screen readers). */
    switchToMultiYearViewLabel = 'Kies maand en jaar';
    /** A label for the cancel button */
    cancelBtnLabel = 'Annuleren';
    /** A label for the set button */
    setBtnLabel = 'Kies';
    /** A label for the range 'from' in picker info */
    rangeFromLabel = 'Van';
    /** A label for the range 'to' in picker info */
    rangeToLabel = 'Tot';
    /** A label for the hour12 button (AM) */
    hour12AMLabel = 'AM';
    /** A label for the hour12 button (PM) */
    hour12PMLabel = 'PM';
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DefaultIntl, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DefaultIntl });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DefaultIntl, decorators: [{
            type: Injectable
        }] });

class DateFilterModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DateFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.0.7", ngImport: i0, type: DateFilterModule, declarations: [DateFilterComponent], imports: [CommonModule, IonicModule, OwlDateTimeModule, OwlNativeDateTimeModule, FilterModule], exports: [DateFilterComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DateFilterModule, providers: [{ provide: OwlDateTimeIntl, useClass: DefaultIntl }], imports: [CommonModule, IonicModule, OwlDateTimeModule, OwlNativeDateTimeModule, FilterModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: DateFilterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DateFilterComponent],
                    imports: [CommonModule, IonicModule, OwlDateTimeModule, OwlNativeDateTimeModule, FilterModule],
                    providers: [{ provide: OwlDateTimeIntl, useClass: DefaultIntl }],
                    exports: [DateFilterComponent],
                }]
        }] });

/*
 * Public API Surface of ngx-date-filter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DateFilterComponent, DateFilterModule };
